export const BoltIcon = () => {
  return (
    <svg
      width="40"
      height="52"
      viewBox="0 0 40 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.1173 0.948547C28.6224 0.544452 29.2286 0.241381 29.8347 0.241381C31.5521 0.241381 32.7644 2.05981 32.1583 3.67619L25.2887 22.8707H36.4013C37.9166 22.8707 39.2299 24.184 39.2299 25.5983C39.2299 26.4065 38.8258 27.2147 38.2197 27.7198L11.4484 51.3594C10.9433 51.7635 10.3371 51.9655 9.731 51.9655C8.0136 51.9655 6.80132 50.2481 7.40746 48.6317L14.2771 29.3362H2.96242C1.54808 29.3362 0.436823 28.2249 0.436823 26.8106C0.436823 26.0024 0.739894 25.2953 1.24501 24.7901L28.1173 0.948547ZM28.2183 5.19154L4.67982 26.1034H16.6006C17.1057 26.1034 17.6109 26.4065 17.9139 26.8106C18.217 27.2147 18.217 27.8209 18.116 28.326L11.3474 47.1164L35.088 26.1034H23.0661C22.46 26.1034 21.9549 25.9014 21.6518 25.4973C21.3487 24.9922 21.3487 24.4871 21.4498 23.982L28.2183 5.19154Z"
        fill="white"
      />
    </svg>
  );
};
